/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import axios from 'axios';
import $http from '../plugins/axios';

// const BASE_URL = 'http://localhost:3000/local/genome-solidify-api-svc/';

const fetchSystemSetting = async (url: any) => {
  console.log($http);
  const settingRes = await $http.get(url);
  return settingRes;
};
const fetchInitialData = async (url: any, data: any) => {
  console.log($http);
  const res = $http.post(url, data);
  return res;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line consistent-return
const getProfileInfo = async (ohr: string) => {
  // let responseData;
  // const nAxios = axios.create();
  // Axios.defaults.headers.common['x-oauth-config-provider'] = 'cognito-aps1';
  // const accessToken = localStorage.getItem('accessToken');
  // console.log('Access Token', accessToken);
  // nAxios.defaults.headers.common.Authorization = `Bearer ${accessToken}`; // eslint-disable-line
  // nAxios.defaults.headers.common['x-oauth-config-provider'] = 'cognito-aps1';
  let APP_BUILD = 'uat';
  const { host } = window.location;
  console.log(`inside landing service ${host}`);
  // if (host === 'dev.genome.genpact.com') APP_BUILD = 'dev';
  // else if (host === 'uat.genome.genpact.com') APP_BUILD = 'uat';
  if (host === 'genome-eda-rel.azurewebsites.net') APP_BUILD = 'prod';
  // else{}
  // else if (host.includes('localhost')) APP_BUILD = 'uat';
  // $http.defaults.headers.common['x-oauth-config-provider'] = 'okta-acf';
  // https://api.genpact.com/uat/api/employee/v1/lookup?query=703296406
  const response = $http.get(`https://api.genpact.com/${APP_BUILD}/api/employee/v1/lookup?query=${ohr}`);
  return response;
};

export { fetchInitialData, fetchSystemSetting, getProfileInfo };
